import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import normalizeMessages from './Fields/normalizeMessages';

const getClassName = (type, error = false, success = false) => {
    let elementClass;

    switch (type) {
        case 'select':
            elementClass = 'formrow__selectfield-input';
            break;
        case 'text':
        case 'number':
            elementClass = 'formrow__text-input';
            break;
        case 'radio':
            elementClass = 'formrow__radio-input';
            break;
        default:
            elementClass = '';
            break;
    }

    if (error) {
        return `${elementClass} ${elementClass}--validation-error`;
    } else if (success) {
        return `${elementClass} ${elementClass}--validation-success`;
    }

    return elementClass;
};

export default class Formrow extends PureComponent {
    static propTypes = {
        required: PropTypes.bool,
        error: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.string,
        ]),
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element,
        ]).isRequired,
        children: PropTypes.node,
        type: PropTypes.oneOf(['text', 'number', 'select', 'radio']).isRequired,
        success: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.bool,
            ])),
            PropTypes.bool,
            PropTypes.string,
        ]),
        htmlFor: PropTypes.string.isRequired,
        helpLayer: PropTypes.element,
    }

    static defaultProps = {
        error: null,
        success: null,
        required: false,
        children: null,
        helpLayer: null,
    }

    render() {
        const {
            required,
            error,
            label,
            children,
            type,
            success,
            htmlFor,
            helpLayer,
        } = this.props;

        const normalizedError = normalizeMessages(error);

        return (
            <div className="formrow">
                {normalizedError.length > 0 &&
                    <div className="formrow__error-messages">
                        <ul className="error-messages">
                            {normalizedError.map(message =>
                                <li key={message} className="error-messages__item">{message}</li>)}
                        </ul>
                    </div>
                }
                <label className="formrow__label" htmlFor={htmlFor}>
                    {label}
                    {required && <span aria-hidden="true">&nbsp;*</span>}
                </label>
                <div className={getClassName(type, !!error, !!success)}>
                    {children}
                    {helpLayer}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/frontend/components/Formrow.jsx